import axios from 'axios';

const signPluginUrl = `http://127.0.0.1:11368/`

const axiosConfig = {
    timeout: 100 * 1000
};
const localService = {
    /**
     * Lấy danh sách CTS từ plugin
     */
    loadCAList() {
        return axios.get(`${signPluginUrl}api/list`, axiosConfig);
    },

    /**
     * Kí dữ liệu để lấy xml gửi lên sign server = plugin
     */
    signData({ serial = null, username = null, pin = null }: { serial: string | null, username: string | null, pin: string | null, }) {
        const usernameXml = `<username>${username}</username>`;
        return axios.post(`${signPluginUrl}api/sign`, JSON.stringify({ x: usernameXml, s: serial, p: pin }), axiosConfig);
    }
};

export default localService;